import React from 'react'

const CheckboxWrapper = React.forwardRef((props, ref) => (
  <label className='auto-messages-option'>
    <input type='checkbox' {...props} ref={ref} />
    {props.label}
  </label>
))

export default CheckboxWrapper
